/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Statistics_Active_JobsInputs */

const en_admin_statistics_active_jobs = /** @type {(inputs: Admin_Statistics_Active_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active job offers`)
};

const de_admin_statistics_active_jobs = /** @type {(inputs: Admin_Statistics_Active_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktive Jobangebote`)
};

/**
* | output |
* | --- |
* | "Active job offers" |
*
* @param {Admin_Statistics_Active_JobsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_statistics_active_jobs = /** @type {((inputs?: Admin_Statistics_Active_JobsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Statistics_Active_JobsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_statistics_active_jobs(inputs)
	return en_admin_statistics_active_jobs(inputs)
});